import { LegalPage, LegalSection } from "@/components/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Política de Privacidade"
      updated="outubro de 2026"
      testId="privacy-page"
    >
      <LegalSection title="1. Quem somos">
        <p>
          RESOLV, pessoa jurídica de direito privado, inscrita no CNPJ sob o nº
          69.470.510/0001-29, com sede na Rua Jomilda Camargo da Cunha, 293, Kobrasol, São
          José/SC, é a controladora dos dados pessoais coletados neste site, nos termos da Lei
          Geral de Proteção de Dados (Lei nº 13.709/2018 — LGPD).
        </p>
      </LegalSection>

      <LegalSection title="2. Dados que coletamos">
        <p>Coletamos apenas os dados que você nos fornece voluntariamente nos formulários:</p>
        <p>
          <strong className="text-petrol">Solicitação de atendimento:</strong> nome, telefone,
          e-mail (opcional), perfil (imobiliária, proprietário ou inquilino), cidade e a
          descrição da demanda.
        </p>
        <p>
          <strong className="text-petrol">Cadastro de parceiro:</strong> nome, telefone, cidade,
          especialidade, CNPJ ou CPF, experiência e regiões atendidas.
        </p>
        <p>
          Também coletamos dados técnicos de navegação (como endereço IP e tipo de navegador)
          para segurança e melhoria do site.
        </p>
      </LegalSection>

      <LegalSection title="3. Como usamos seus dados">
        <p>Utilizamos os dados exclusivamente para:</p>
        <p>
          responder às suas solicitações, organizar e acompanhar demandas de imóveis, conectar
          você a profissionais parceiros quando necessário à execução do serviço, avaliar
          cadastros de prestadores e melhorar nossos serviços.
        </p>
        <p>Não vendemos dados pessoais e não enviamos comunicações sem relação com a sua solicitação.</p>
      </LegalSection>

      <LegalSection title="4. Compartilhamento">
        <p>
          Quando você solicita um serviço, os dados estritamente necessários à execução (como
          nome, telefone e detalhes da demanda) podem ser compartilhados com profissionais
          parceiros da rede Resolv, sempre com a finalidade de resolver a sua solicitação.
        </p>
      </LegalSection>

      <LegalSection title="5. Segurança e retenção">
        <p>
          Adotamos medidas técnicas e organizacionais para proteger seus dados contra acessos
          não autorizados. Mantemos os dados pelo tempo necessário para cumprir as finalidades
          descritas nesta política e obrigações legais.
        </p>
      </LegalSection>

      <LegalSection title="6. Seus direitos">
        <p>
          Nos termos da LGPD, você pode solicitar a confirmação, o acesso, a correção, a
          anonimização, a portabilidade ou a exclusão dos seus dados pessoais, além de revogar
          consentimentos. Para exercer esses direitos, escreva para{" "}
          <a
            href="mailto:contato@resolvsc.com.br"
            className="font-semibold text-brand hover:underline"
          >
            contato@resolvsc.com.br
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="7. Alterações desta política">
        <p>
          Esta política pode ser atualizada periodicamente. A versão vigente estará sempre
          disponível nesta página, com a data da última atualização.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
